import { FaArrowTrendDown, FaArrowTrendUp } from "react-icons/fa6";
import {
    spliteDate,
    humanizeNumber,
    fixFloatNumber
} from "../../tools/market/functions"


const generateIcon = (row) => {
    if (row.alarm.stock_rights_fund === 'صعودی') {
        return <FaArrowTrendUp />
    }else if (row.alarm.stock_rights_fund === 'ریزشی'){
        return <FaArrowTrendDown className="text-danger" />
    }
}

const successStyles = "text-success bg-success border-success rounded-3 px-5"
const warningStyle = "text-warning bg-warning border-warning rounded-3 px-5"
const primaryStyles = "text-white bg-dark border-primary rounded-3 px-5"
const secondaryStyles = "text-white bg-dark border-secondary rounded-3 px-5"

const config = [
    {
        key: "date",
        value: 'تاریخ',
        sortable: false,
        classes: (row) => row.date !== undefined ? primaryStyles : null,
        renderer: (row, filter) => row.date !== undefined ? spliteDate(row.date): 'x'
    },
    {
        key: "close",
        value: "شاخص کل",
        sortable: false,
        classes: (row) => row.close !== undefined ? secondaryStyles : null,
        renderer: (row) => row.close !== undefined ? humanizeNumber(row.close) : 'x'
    },
    {
        key: "percent",
        value: "تغییر شاخص کل",
        sortable: false,
        classes: (row) => row.close !== undefined ? row.percent > 0 ? successStyles : warningStyle : '',
        renderer: (row) => row.close !== undefined ? fixFloatNumber(row.percent) : 'x'
    },
    {
        key: "equal_weight",
        value: "شاخص هموزن",
        sortable: false,
        classes: (row) => row.types.totalequel_weithed !== undefined ? secondaryStyles : null,
        renderer: (row) => row.types !== undefined && row.types.totalequel_weithed !== undefined ? humanizeNumber(row.types.totalequel_weithed.value) : 'x'
    },
    {
        key: "equal_weight_percent",
        value: "تغییر هموزن",
        sortable: false,
        classes: (row) => row.types !== undefined && row.types.totalequel_weithed ? row.totalequel_weithed_percent > 0 ? successStyles : warningStyle : '',
        renderer: (row) => row.types !== undefined && row.types.totalequel_weithed !== undefined ? (fixFloatNumber(row.totalequel_weithed_percent)) : 'x'
    },
    {
        key: "alarm",
        value: "آلارم بازار",
        sortable: false,
        // rendererClassStockRight: (row) => row.alarm !== undefined ? row.alarm.stock_rights === 'صعودی' ? successStyles : row.alarm.stock_rights === 'ریزشی' ? warningStyle: null : null,
        rendererClassStockRightFund: (row) => row.alarm !== undefined ? row.alarm.stock_rights_fund === 'صعودی' ? successStyles : row.alarm.stock_rights_fund === 'ریزشی' ? warningStyle : secondaryStyles : null,
        // rendererClassFundFixed: (row) => row.alarm !== undefined ? row.alarm.fund_fixed === 'صعودی' ? 'text-primary' : row.alarm.fund_fixed === 'ریزشی' ? 'text-danger' : null : null,

        // rendererStockRight: (row) => row.alarm !== undefined ? row.alarm.stock_rights : '-',
        rendererStockRightFund: (row) => row.alarm !== undefined ? <span className="d-flex align-items-center gap-2">{generateIcon(row)} {row.alarm.stock_rights_fund} </span> : '-',
        // rendererFundFixed: (row) => row.alarm !== undefined ? row.alarm.fund_fixed : '-'
    },
    {
        key: "activity",
        value: "فعالیت",
        sortable: false,
        // rendererClassStockRight: (row) => row.alarm !== undefined ? row.alarm.stock_rights === 'صعودی' ? 'text-primary' : row.alarm.stock_rights === 'ریزشی' ? 'text-danger' : null : null,
        rendererClassStockRightFund: (row) => row.alarm !== undefined ? row.alarm.stock_rights_fund === 'صعودی' ? successStyles : row.alarm.stock_rights_fund === 'ریزشی' ? warningStyle : secondaryStyles : null,
        // rendererClassFundFixed: (row) => row.alarm !== undefined ? row.alarm.fund_fixed === 'صعودی' ? 'text-primary' : row.alarm.fund_fixed === 'ریزشی' ? 'text-danger' : null : null,

        // rendererStockRight: (row) => row.alarm !== undefined ? row.alarm.stock_rights === 'صعودی' ? 'سرمایه گذاری میان مدت' : row.alarm.stock_rights === 'ریزشی' ? 'نقد و درآمد ثابت' : row.alarm.stock_rights === 'نوسانی' ? 'نوسانگیری' : null : null,
        rendererStockRightFund: (row) => row.alarm !== undefined ? row.alarm.stock_rights_fund === 'صعودی' ? 'سرمایه گذاری میان مدت' : row.alarm.stock_rights_fund === 'ریزشی' ? 'نقد و درآمد ثابت' : row.alarm.stock_rights_fund === 'نوسانی' ? 'نوسانگیری' : null : null,
        // rendererFundFixed: (row) => row.alarm !== undefined ? row.alarm.fund_fixed === 'صعودی' ? 'سرمایه گذاری میان مدت' : row.alarm.fund_fixed === 'ریزشی' ? 'نقد و درآمد ثابت' : row.alarm.fund_fixed === 'نوسانی' ? 'نوسانگیری' : null : null,
    },
]

export { config }